import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

export const Expand = styled.div`
    padding: 16px;
`;

export const ExpandTable = styled.table`
    white-space: normal;
    color: ${Variables.Colors.n100};
    width: auto;
    margin-bottom: 16px;
`;
export const ExpandTBody = styled.tbody`
    padding-top: 16px;
`;
export const ExpandTR = styled.tr``;
export const ExpandTH = styled.th`
    text-align: left;
    vertical-align: top;
    padding-right: 1em;
    font-weight: 500;
    white-space: nowrap;
`;
export const ExpandTD = styled.td``;
export const ExpandTitle = styled.h3`
    margin: 18px 0 0 0;
    font-weight: 500;
    font-size: 16px;
    text-decoration: underline;
`;

export const TableIconCell = styled.div`
    display: flex;
    flex-direction: row;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
`;
